import { IConfig } from 'ngx-mask'

export var NgxMaskConfig: Partial<IConfig> = {
  // ngx-mask novos vem com validation ativo por padrão...
  // O problema é que nossos códigos não estão preparados para essas validações (não mostram mensagem,
  //  não avisam ao salvar), então por enquanto deixei desativado.
  validation: false,
};
